import script from "./CareerApplicationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CareerApplicationPage.vue?vue&type=script&setup=true&lang=js"

import "./CareerApplicationPage.vue?vue&type=style&index=0&id=489e6c47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-489e6c47"]])

export default __exports__